import { FunctionComponent, memo, useMemo } from 'react';
import { StoryCardEventContent } from '../../../../services';
import {
  EventItemContent,
  EventItemUnavailable,
  useIsEventUnavailable,
} from '../../../components/EventItem';
import { FeedCardMargin } from '../FeedCardMargin';
import { FeedCardProps } from '../model';

import classes from './FeedCardEvent.module.scss';

export const FeedCardEvent: FunctionComponent<FeedCardProps> = memo(({ card, chatId }) => {
  const isEventUnavailable = useIsEventUnavailable();

  const { content, event } = card;

  const { headline } = content as StoryCardEventContent;

  const eventContent = useMemo(() => {
    if (isEventUnavailable(event)) {
      return <EventItemUnavailable />;
    }

    if (!event) {
      return null;
    }

    return (
      <div className={classes['event-content']}>
        <EventItemContent event={event} showDescription showViewLink />
      </div>
    );
  }, [event, isEventUnavailable]);

  const HeadlineTag = chatId ? 'div' : 'h2';

  return (
    <FeedCardMargin top left right>
      {headline && <HeadlineTag className={classes['headline']}>{headline}</HeadlineTag>}
      {eventContent}
    </FeedCardMargin>
  );
});
